import Tween from "tween.ts";
import Animation from "../Animation";
import Angle from "../../entities/Angle/Angle";

export default class DrawAngleAnim extends Animation {
  private Anim = Animation.getInstance();
  private isStopped = false;
  constructor(Angle: Angle, onComp: () => void, resolve:() => void) {
    super();
    

    if(this.Anim.getIsCancelled()) {
      Angle.scale.set(1);
      Angle.setVisible(true)
      resolve();
      return 
    };

    Angle.visible = true;
    Angle.scale.set(0.3);
    
    const v = { s: Angle.scale };

    new Tween.Tween(v)
      .to({ s: 1 }, 500)
      .easing(Tween.Easing.Linear.None)
      .onUpdate(v=>{
        const isCancelled =  this.Anim.getIsCancelled();
        if(isCancelled) {
          this.isStopped = true;
          Angle.scale.set(1);
          onComp();
        }
        if(!this.isStopped) {
          Angle.scale.set(v.s)
        }
         
      })
      .onComplete(() => onComp())
      .start()
  }
}